import { render, staticRenderFns } from "./editHouse.vue?vue&type=template&id=1678ed42&scoped=true&"
import script from "./editHouse.vue?vue&type=script&lang=js&"
export * from "./editHouse.vue?vue&type=script&lang=js&"
import style0 from "./editHouse.vue?vue&type=style&index=0&id=1678ed42&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1678ed42",
  null
  
)

export default component.exports